/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prettier/prettier */
/* eslint-disable no-undef */
import { Client } from "@microsoft/microsoft-graph-client";
import React from "react";
import { IMaillight } from "./interfaces";
import { Callout, DetailsList, Selection, DetailsListLayoutMode, DirectionalHint, IColumn, SelectionMode, Spinner, SpinnerSize, TooltipHost, FontSizes, getTheme, FontWeights, Toggle, IChoiceGroupOption, ChoiceGroup, DatePicker, defaultDatePickerStrings, PrimaryButton } from "@fluentui/react";
import { CalendarStyles, styles2 } from "./Module";


const theme = getTheme();

interface IMailsFromProps {
    client: Client;
    mailfrom: string;
    token: string;
}
interface IMailsFromState {
    // openPanel: boolean;
    mails: IMaillight[];
    show: boolean;
    previewOn: boolean;
    index: string;
    filelink: string;
    content: string;
    displaySpinner: boolean;
    selectionDetails: string;
    zoom: number;
    PagerPage: number;
    PagerTotalPages: number;
    PagerTotalDek: number;
    modDek: number;
    PagerCurrentDek: number;
    filteredItems: any[];
    isFiltered: boolean;
    showCustom: boolean;
    startDate: string;
    endDate: string;
    selectedKey: string;
}

export class MailsFrom extends React.Component<IMailsFromProps, IMailsFromState> {
    private _selection: Selection;
    private _allItems: any[];
    private mails: IMaillight[] = [];
    private CurrentPage: number = 1;
    protected targetButton: any;
    protected dateFrom: Date = new Date();   //new Date((new Date()).setDate((new Date()).getDate() - 90));
    protected dateTo: Date = new Date((new Date()).setDate((new Date()).getDate() - 7));
    constructor(props: IMailsFromProps) {
        super(props);
        const _div: number = 1; //itemslist.length / 10;
        const _totalDek: number = 1;// (_div / 10) + 1;
        const _modDek: number = 0;// (_div % 10);

        // const startDate = new Date();
        const endDate = new Date((new Date()).setDate((new Date()).getDate() - 1));

        this.state = {
            selectedKey: 'week',
            startDate: new Date().toISOString().split('.')[0] + 'Z', endDate: endDate.toISOString().split('.')[0] + 'Z',
            showCustom: false,
            filteredItems: null, isFiltered: false, PagerPage: 1,
            PagerTotalPages: _div, PagerTotalDek: _totalDek, modDek: _modDek, PagerCurrentDek: 1,
            zoom: 0.9, mails: [], show: false, previewOn: false, index: null, filelink: null, content: '', displaySpinner: true, selectionDetails: ''
        };
        this.targetButton = React.createRef();
        this.OnInit = this.OnInit.bind(this);
        this.renderDocumentRow = this.renderDocumentRow.bind(this);
        this.toggleAllowPreview = this.toggleAllowPreview.bind(this);

        this._selection = new Selection({
            onSelectionChanged: () => {
                this.setState({
                    selectionDetails: this._getSelectionDetails(),
                });
            },
        });
    }
    componentDidMount(): void {
        // const endDate = new Date((new Date()).setDate((new Date()).getDate() - 1));
        this.OnInit(this.dateFrom.toISOString().split('.')[0] + 'Z', this.dateTo.toISOString().split('.')[0] + 'Z', this.state.selectedKey, this.props.mailfrom);
    }

    UNSAFE_componentWillReceiveProps(nextProps: Readonly<IMailsFromProps>): void {
        console.log(this.state.selectedKey);

        switch (this.state.selectedKey) {
            case "day":
                this.dateTo = new Date((new Date()).setDate((new Date()).getDate() - 1));
                break;
            case "week":
                this.dateTo = new Date((new Date()).setDate((new Date()).getDate() - 7));
                break;
            case "month":

                this.dateTo = new Date((new Date()).setDate((new Date()).getDate() - 30));
                break;

        }

        this.OnInit(this.dateFrom.toISOString().split('.')[0] + 'Z', this.dateTo.toISOString().split('.')[0] + 'Z', this.state.selectedKey, nextProps.mailfrom);
    }
    private _onColumnClick = (_ev: React.MouseEvent<HTMLElement>, _column: IColumn): void => {
    }
    private _getSelectionDetails() {
        const o = this._selection.getSelection()[0];
        console.log("Selection", o, " Selections", this._selection);
        return "s";
    }
    private columns: IColumn[] = [

        {
            key: 'column3',
            name: 'Subject',
            fieldName: 'subject',
            minWidth: 100,
            maxWidth: 200,
            isResizable: true,
            onColumnClick: this._onColumnClick,
            onRender: (_item: IMaillight) => (
                <div style={{ textAlign: "left" }}>
                    <div id={_item.domId} style={{ fontWeight: FontWeights.semibold, fontSize: FontSizes.smallPlus, color: theme.palette.neutralPrimary }}> {_item.subject}</div>
                    <div id={_item.domId} style={{ fontSize: FontSizes.smallPlus, color: theme.palette.blackTranslucent40, textWrap: 'pretty' }}> {_item.bodyPreview.substring(0, 200)}...</div>
                    <div style={{ fontWeight: FontWeights.semibold, fontSize: FontSizes.smallPlus, color: theme.palette.neutralPrimary }}>{
                        new Date(_item.sentDateTime).toLocaleString('el-GR', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                            // second: '2-digit',
                            hour12: false,
                        })

                    }</div>
                </div>
                // <TooltipHost content={new Date(_item.receivedDateTime).toLocaleDateString() + " " + new Date(_item.receivedDateTime).toLocaleTimeString()}>
                //     {_item.subject}
                // </TooltipHost>
            ),
            data: 'string',
            // onRender: (item: IMaillight) => {
            //     return <span></span>;
            // },
            isPadded: true,
        },


    ];
    private OnInit(start, end, selected, mailFrom) {

        this.mails = [];

        this.setState({ displaySpinner: true });
        this.props.client
            .api(`https://graph.microsoft.com/v1.0/me/messages?$filter=(from/emailAddress/address eq '${mailFrom}') and (receivedDateTime ge ${end}) and (receivedDateTime le ${start})&Top=1000`)
            .get()
            .then((response: any) => {
                let counter: number = 0;
                if (response.value.length <= 0) this.setState({ displaySpinner: false });
                response.value.filter(x => x.body.content.length > 1 && !x.subject.startsWith('Accepted')
                    && !x.subject.startsWith('New Time Proposed')
                    && !x.subject.startsWith('Declined')).map((item) => {
                        this.mails.push({
                            domId: 'domId' + counter.toString(),
                            id: item.id,
                            createdDateTime: item.createdDateTime,
                            lastModifiedDateTime: item.lastModifiedDateTime,
                            categories: item.categories,
                            receivedDateTime: item.receivedDateTime,
                            sentDateTime: item.sentDateTime,
                            subject: item.subject,
                            bodyPreview: item.bodyPreview,
                            webLink: item.webLink,
                            inferenceClassification: item.inferenceClassification,
                            body: {
                                contentType: item.body.contentType,
                                content: item.body.content
                            },
                            sender: item.sender.emailAddress.address,
                            from: item.from.emailAddress.address
                        });
                        counter++;
                    }

                    );

                //   const initials: IMaillight[] = this._insertPartial(this.mails, this.CurrentPage, 10);
                this.setState({ filteredItems: this.mails, displaySpinner: false, selectedKey: selected });
            }).catch(() => {
                this.setState({ displaySpinner: false });
            });
    }
    private toggleAllowPreview() {
        this.setState({ previewOn: !this.state.previewOn });
    }

    public renderDocumentRow(props: any, defaultRender: any): JSX.Element {
        //  const filelink = props.item.ServerRedirectedEmbedURL !== undefined && props.item.ServerRedirectedEmbedURL && props.item.ServerRedirectedEmbedURL;
        return (
            <div
                onMouseEnter={() => {

                    if (props.item.id !== undefined) {

                        this.setState({
                            index: '#' + props.item.domId, show: true,
                            content: props.item.body.content
                        });
                    }
                    // else
                    //     this.setState({ index: '#X' + props.item.id, show: false, });
                }}
                onClick={() => {
                    this.setState({ index: '#' + props.item.domId });
                }}
            // onMouseOut={() => {
            //     this.setState({ index: '#X' + props.item.id, show: false, });
            // }}
            >
                {defaultRender(props)}
            </div>);
    }
    private options: IChoiceGroupOption[] = [
        { key: 'day', text: 'Day', iconProps: { iconName: 'CalendarDay' } },
        { key: 'week', text: 'Week', iconProps: { iconName: 'CalendarWeek' } },
        { key: 'month', text: 'Month', iconProps: { iconName: 'Calendar' }, },
        { key: 'custom', text: 'Custom', iconProps: { iconName: 'SearchCalendar' }, },
    ];
    private _onItemInvoked(item: any) {
        Office.context.mailbox.displayMessageForm(item.id);
    }
    public render(): JSX.Element {
        let startDate: Date;
        let endDate: Date;

        return (
            <React.Fragment>



                <div onClick={() => { this.setState({ show: false }) }} >
                    <ChoiceGroup selectedKey={this.state.selectedKey} options={this.options} onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, option?: IChoiceGroupOption) => {

                        switch (option.key) {
                            case 'day':
                                this.setState({ showCustom: false, selectedKey: 'day' });
                                startDate = new Date();
                                endDate = new Date(startDate.setDate(startDate.getDate() - 1));

                                this.OnInit(new Date().toISOString().split('.')[0] + 'Z', endDate.toISOString().split('.')[0] + 'Z', 'day', this.props.mailfrom);
                                break;
                            case 'week':
                                this.setState({ showCustom: false, selectedKey: 'week' });
                                startDate = new Date();
                                endDate = new Date(startDate.setDate(startDate.getDate() - 7));

                                this.OnInit(new Date().toISOString().split('.')[0] + 'Z', endDate.toISOString().split('.')[0] + 'Z', 'week', this.props.mailfrom);
                                break;
                            case 'month':
                                this.setState({ showCustom: false, selectedKey: 'month' });
                                startDate = new Date();
                                endDate = new Date(startDate.setDate(startDate.getDate() - 30));

                                this.OnInit(new Date().toISOString(), endDate.toISOString().split('.')[0] + 'Z', 'month', this.props.mailfrom);
                                break;
                            case 'custom':
                                this.setState({ showCustom: true, selectedKey: 'custom' });
                                break;
                        }
                        console.log('ev', ev, option);
                    }} />
                    <div style={{ marginTop: 20, display: `${this.state.showCustom ? 'block' : 'none'}` }}>
                        <DatePicker
                            label="Date From"
                            placeholder="Date From..."
                            value={this.dateFrom}
                            ariaLabel="Select a date"
                            className={CalendarStyles.control}
                            strings={defaultDatePickerStrings}
                            onSelectDate={(date: Date | null | undefined) => {
                                this.dateFrom = date;
                            }}
                        />
                        <DatePicker
                            label='Date To'
                            value={new Date()}
                            placeholder="Date To..."
                            ariaLabel="Select a date"
                            className={CalendarStyles.control}
                            strings={defaultDatePickerStrings}
                            onSelectDate={(date: Date | null | undefined) => {
                                this.dateTo = date;
                                this.OnInit(this.dateFrom.toISOString().split('.')[0] + 'Z', this.dateTo.toISOString().split('.')[0] + 'Z', 'custom', this.props.mailfrom);
                            }}
                        />
                    </div>
                    <Toggle label="Allow Preview" styles={{ root: { marginLeft: 20, paddingTop: 30 } }} checked={this.state.previewOn} onChange={this.toggleAllowPreview} />



                    {this.state.displaySpinner &&
                        <Spinner label="Nope, still Loading..." ariaLive="assertive" labelPosition="left" size={SpinnerSize.large} />
                    }

                    {!this.state.displaySpinner &&
                        <div>
                            <DetailsList
                                // items={this._allItems}
                                items={this.state.filteredItems}
                                styles={{ root: { fontSize: FontSizes.small } }}
                                columns={this.columns}
                                //className={styles.rows}
                                //  onRenderItemColumn={this.renderItemColumn}
                                setKey="set"
                                layoutMode={DetailsListLayoutMode.justified}
                                //  onRenderItemColumn={this.renderColumn}
                                selection={this._selection}
                                selectionMode={SelectionMode.none}
                                selectionPreservedOnEmptyClick={true}
                                ariaLabelForSelectionColumn="Toggle selection"
                                ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                                checkButtonAriaLabel="select row"
                                onItemInvoked={this._onItemInvoked}
                                onRenderRow={this.renderDocumentRow}
                            />
                            {
                                this.state !== null && this.state.show && this.state.previewOn &&
                                <Callout
                                    className={styles2.callout}
                                    beakWidth={50}
                                    coverTarget={false}
                                    role="dialog"
                                    gapSpace={2}
                                    target={this.state.index}
                                    // onDismiss={toggleIsCalloutVisible}
                                    directionalHintFixed={false}
                                    directionalHint={DirectionalHint.topAutoEdge}

                                >
                                    <div style={{ margin: 3, zoom: `${this.state.zoom}`, overflow: 'auto', border: 'outset 1px', width: '99%', height: 400 }}>{this.dynamic(this.state.content)}
                                    </div>
                                </Callout>
                            }
                        </div>

                    }
                </div>
            </React.Fragment>);

    }
    private dynamic = (dom) => { return <div dangerouslySetInnerHTML={{ __html: dom }}></div>; }
}
